export const COARSE_POINTER_QUERY = '(pointer: coarse)';
const PERF_QUERY_PARAMS = ['perf', 'debug'];

export function readStartLevelIndex(search = window.location.search, levelCount = 1) {
  const params = new URLSearchParams(search);
  const requestedLevel = Number(params.get('level') ?? params.get('sector'));

  if (!Number.isFinite(requestedLevel)) {
    return 0;
  }

  return Math.min(Math.max(Math.trunc(requestedLevel) - 1, 0), levelCount - 1);
}

export function readPerformanceDebugEnabled(search = window.location.search) {
  const params = new URLSearchParams(search);
  return PERF_QUERY_PARAMS.some((param) => params.get(param) === '1');
}

export function readForceTouchControlsEnabled(search = window.location.search) {
  const params = new URLSearchParams(search);

  return (
    params.get('controls') === 'touch' ||
    params.get('touch') === '1'
  );
}

export function canUseTouchControls({
  matchMedia = window.matchMedia,
  navigator = window.navigator,
  search = window.location.search,
} = {}) {
  const hasCoarsePointer = matchMedia?.(COARSE_POINTER_QUERY)?.matches ?? false;

  return (
    readForceTouchControlsEnabled(search) ||
    hasCoarsePointer ||
    navigator.maxTouchPoints > 0
  );
}
